module.exports = __webpack_public_path__ + "static/media/logo-path-finder.96392479.webp";